import React from 'react';
import { signOut } from 'aws-amplify/auth';
import { useErrorHandler } from '@lib/useErrorHandler';

import { dispatchAuthStateChangeEvent, AuthState } from './utils';
import { useHistory } from 'react-router-dom';

export interface Props {
  children?: React.ReactNode
}

export const SignOut = ({ children }: Props) => {
  const handleError = useErrorHandler();
  const history = useHistory();

  const handleSignOut = async () => {
    try {
      await signOut(); // N.B. async await added for testing purposes
      await new Promise(r => setTimeout(r, 500));
      dispatchAuthStateChangeEvent(AuthState.SignedOut);
      history.push('/');
    } catch (err) {
      handleError(err);
    }
  };

  return (
    <div onClick={handleSignOut}>
      {children}
    </div>
  );
};
